import { AxiosResponse } from 'axios';
import { SET_YURTZEITENS, SET_YURTZEITEN, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_YURTZEITEN_ISLOADING,
  DELETE_YURTZEITEN,
  EDIT_YURTZEITEN,
  GET_YURTZEITEN,
  GET_YURTZEITENS,
  REGISTER_YURTZEITEN,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Yurtzeiten from '@/services/yurtzeiten';
import { Module } from 'vuex';
import { EditYurtzeiten, RegisterYurtzeiten, GetYurtzeiten } from '@/dtos/yurtzeiten.dto';

const yurtzeiten: Module<any, {}> = {
  state: {
    yurtzeiten: {
      data: null,
      isLoading: false,
    },
    yurtzeitens: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    yurtzeiten: (state: { yurtzeiten: any }) => state.yurtzeiten,
    yurtzeitens: (state: { yurtzeitens: any }) => state.yurtzeitens,
  },
  mutations: {
    [SET_YURTZEITEN]: (
      state: { yurtzeiten: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeiten.data = payload.data) : null,
        (state.yurtzeiten.isLoading = payload.isLoading);
    },
    [SET_YURTZEITENS]: (
      state: { yurtzeitens: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitens.data = payload.data) : null,
        (state.yurtzeitens.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_YURTZEITEN]: async ({ commit }: any, payload: FormData) => {
      commit(SET_YURTZEITEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten.registerYurtzeiten(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITENS]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITENS, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten.getYurtzeitens(
        payload as GetYurtzeiten
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITENS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITENS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITENS, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten.getYurtzeitens(
        payload as GetYurtzeiten
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN, { isLoading: false });
        return false;
      }
    },
    [EDIT_YURTZEITEN]: async ({ commit }: any, payload: FormData) => {
      commit(SET_YURTZEITEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten.editYurtzeiten(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN, { isLoading: false });
        return false;
      }
    },
    [DELETE_YURTZEITEN]: async ({ commit }: any, payload: string) => {
      commit(SET_YURTZEITEN, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten.deleteYurtzeiten(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN, { isLoading: false });
        return false;
      }
    },
    [CLEAR_YURTZEITEN_ISLOADING]: ({ commit }) => {
      commit(SET_YURTZEITEN, { isLoading: false });
      commit(SET_YURTZEITENS, { isLoading: false });
    },
  },
};

export default yurtzeiten;
